import { render } from "./SaleDiffere.vue?vue&type=template&id=60aa3454&scoped=true"
import script from "./SaleDiffere.vue?vue&type=script&lang=js"
export * from "./SaleDiffere.vue?vue&type=script&lang=js"

import "./SaleDiffere.vue?vue&type=style&index=0&id=60aa3454&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aa3454"]])

export default __exports__